import { get } from 'services/request';
import { IRefIds } from '../constants/refs';

export interface IAudioDashboardGrid {
  id: number;
  ref: number;
  name: string;
  pending: number;
  doing: number;
  pendingReview: number;
  done: number;
  donePercent: string;
}

// Simple word count for Vocabulary and Cultural Vocabulary
export interface IAudioWordsCountSimple {
  wordCounts: {
    any: number;
  };
  ids: number[];
}

// Gender-based word count for Sentences, Items, Segments
export interface IAudioWordsCountGender {
  wordCounts: {
    m: number;
    f: number;
    mf: number;
  };
  ids: {
    m: number[];
    f: number[];
    mf: number[];
  };
}

// Male/Female only word count for Dialog Segments
export interface IAudioWordsCountMaleFemale {
  wordCounts: {
    m: number;
    f: number;
  };
  ids: {
    m: number[];
    f: number[];
  };
}

export type IAudioWordsCount = IAudioWordsCountSimple | IAudioWordsCountGender | IAudioWordsCountMaleFemale;

export default class AudioCreateSetModel {
  async getWordsCount(courseId: number, targetDialectId: number, ref: IRefIds, startLesson: number, endLesson: number) {
    return await get<IAudioWordsCount>(
      `/courses/${courseId}/target-dialects/${targetDialectId}/refs/${ref}/audio-words-count`,
      {
        startLesson,
        endLesson,
      },
    );
  }

  async createSets(
    courseId: number,
    targetDialectId: number,
    ref: IRefIds,
    startLesson: number,
    endLesson: number,
    artists: number[],
  ) {
    return await get<IAudioWordsCount>(
      `/courses/${courseId}/target-dialects/${targetDialectId}/refs/${ref}/audio-create-sets`,
      {
        startLesson,
        endLesson,
        artists: artists.join(','),
      },
    );
  }
}
